
            if (window?.__sw__?.assetPath) {
                __webpack_public_path__ = window.__sw__.assetPath + '/bundles/sellopsthankyoupageeffects/';
            }
        